/*  
 *  Archivo destinado a manejar todas las funciones responsables de comunicación con 
 *  el servidor, referentes al usuario.
 */

import fetchData from "./utils/fetchData";

const url = process.env.REACT_APP_SERVER_URL + '/categorias';

export const getCategorias = async (currentUser, dispatch) => {
    dispatch({ type: 'START_LOADING' });

    //console.log('-------------->> getCategorias');
    //console.log(currentUser);

    let body = null;
    
    //SEND REQUEST WITH FETCH
    const data = await fetchData({ url: url + `/getAllRows`, body, token: currentUser.token }, dispatch);
    const result = data?.result;

    if (result) {
        dispatch({ type: 'UPDATE_CATEGORIAS', payload: result });
    } else {

    }

    dispatch({ type: 'END_LOADING' })
}
